export default __webpack_public_path__ + "static/media/no-connection.13703068.svg";